import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    /**
     * Constructor
     */
    constructor(private _authService: AuthService)
    {
    }

    

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    // {
    //     // Clone the request object
    //     let newReq = req.clone();

    //     // // let refreshTokenInit = localStorage.getItem('refreshTokenInit');
    //     // // let refreshToken = localStorage.getItem('refreshToken');

    //     // // if(refreshTokenInit != 'true' && this._authService.accessToken && AuthUtils.isTokenExpired(this._authService.accessToken))
    //     // // {
    //     // //     let refreshToken = localStorage.getItem('refreshToken');

    //     // //     if(refreshToken == undefined || refreshToken == null || refreshToken == '' ||
    //     // //         AuthUtils.isTokenExpired(refreshToken)){
    //     // //             this._authService.signOut();
    //     // //             location.reload();
    //     // //         }

    //     // //     let userId = localStorage.getItem('userId');
    //     // //     localStorage.setItem('refreshTokenInit','true');
    //     // //     this._authService.getRefreshToken(userId).subscribe((response: any)=>{
    //     // //         if(response && response.data){
    //     // //             this._authService.accessToken = response.data.token;
    //     // //             localStorage.setItem('refreshToken', response.data.refreshToken);
    //     // //             localStorage.setItem('refreshTokenInit','false');
    //     // //             if ( this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken) )
    //     // // {
    //     // //     newReq = req.clone({
    //     // //         headers: req.headers.set('authtoken', 'Bearer ' + this._authService.accessToken)
    //     // //     });
    //     // // }

    //     // // // Response
    //     // // return next.handle(newReq).pipe(
    //     // //     catchError((error) => {

    //     // //         // Catch "401 Unauthorized" responses
    //     // //         if ( error instanceof HttpErrorResponse && error.status === 401 )
    //     // //         {
    //     // //             // Sign out
    //     // //             this._authService.signOut();

    //     // //             // Reload the app
    //     // //             location.reload();
    //     // //         }

    //     // //         return throwError(error);
    //     // //     })
    //     // // );
    //     // //         }
    //     // //     });
    //     // // }
    //     // // else{
    //     // //     if ( this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken) )
    //     // // {
    //     // //     newReq = req.clone({
    //     // //         headers: req.headers.set('authtoken', 'Bearer ' + this._authService.accessToken)
    //     // //     });
    //     // // }
    //     // // else if(newReq.url.includes('/refreshToken')){
    //     // //     newReq = req.clone({
    //     // //         headers: req.headers.set('refreshtoken', 'Bearer ' + refreshToken)
    //     // //     });
    //     // // }

    //     // // // Response
    //     // // return next.handle(newReq).pipe(
    //     // //     catchError((error) => {

    //     // //         // Catch "401 Unauthorized" responses
    //     // //         if ( error instanceof HttpErrorResponse && error.status === 401 )
    //     // //         {
    //     // //             // Sign out
    //     // //             this._authService.signOut();

    //     // //             // Reload the app
    //     // //             location.reload();
    //     // //         }

    //     // //         return throwError(error);
    //     // //     })
    //     // // );
    //     // // }
    //     // Request
    //     //
    //     // If the access token didn't expire, add the Authorization header.
    //     // We won't add the Authorization header if the access token expired.
    //     // This will force the server to return a "401 Unauthorized" response
    //     // for the protected API routes which our response interceptor will
    //     // catch and delete the access token from the local storage while logging
    //     // the user out from the app.
    //     if ( this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken) )
    //     {
    //         newReq = req.clone({
    //             headers: req.headers.set('authtoken', 'Bearer ' + this._authService.accessToken)
    //         });
    //     }

    //     // Response
    //     return next.handle(newReq).pipe(
    //         catchError((error) => {

    //             // Catch "401 Unauthorized" responses
    //             if ( error instanceof HttpErrorResponse && error.status === 401 )
    //             {
    //                 // Sign out
    //                 this._authService.signOut();

    //                 // Reload the app
    //                 location.reload();
    //             }

    //             return throwError(error);
    //         })
    //     );
    // }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq = req;
        const token = this._authService.accessToken
        if (token != null && !authReq.url.includes('/refreshToken')) {
          authReq = this.addTokenHeader(req, token);
        }
        else{
            authReq = this.addRefreshTokenHeader(req, localStorage.getItem('refreshToken'));
        }
    
        return next.handle(authReq).pipe(catchError(error => {
          if (error instanceof HttpErrorResponse && authReq.url.includes('/refreshToken') && error.status === 401) {
            this._authService.signOut();
            location.reload();
          }
          else if (
            error instanceof HttpErrorResponse &&
            error.status === 403 &&
            this.isDeactivatedAccountError(error) &&
            !authReq.url.includes('auth/signin') &&
            !authReq.url.includes('/api/token')
          ) {
            this._authService.signOut();
            location.reload();
          }
          else if (error instanceof HttpErrorResponse && !authReq.url.includes('auth/signin') && error.status === 401) {
            return this.handle401Error(authReq, next);
          }
    
          return throwError(error);
        }));
      }

      private isDeactivatedAccountError(error: HttpErrorResponse): boolean {
        const deactivatedMessage = 'Your account has been deactivated. Please contact administrator.';
        return error.error?.failureMessage === deactivatedMessage || error.error?.message === deactivatedMessage;
      }

      private addTokenHeader(request: HttpRequest<any>, token: string) {
        /* for Spring Boot back-end */
        // return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
    
        /* for Node.js Express back-end */
        return request.clone({ headers: request.headers.set('authtoken', 'Bearer ' + token) });
      }

      //
      private addRefreshTokenHeader(request: HttpRequest<any>, token: string) {
        /* for Spring Boot back-end */
        // return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
    
        /* for Node.js Express back-end */
        return request.clone({ headers: request.headers.set('refreshtoken', 'Bearer ' + token) });
      }

      private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        const token = localStorage.getItem('refreshToken');

        if(AuthUtils.isTokenExpired(token)){
            this._authService.signOut();
            location.reload();
        }

        if (AuthUtils.isTokenExpired(this._authService.accessToken)) {
          //this.isRefreshing = true;
          this.refreshTokenSubject.next(null);
    
          
          const userId = localStorage.getItem('userId');
          if (token)
            return this._authService.getRefreshToken(userId, token).pipe(
              switchMap((token: any) => {
                //this.isRefreshing = false;
    
                //this.tokenService.saveToken(token.accessToken);
                //this.refreshTokenSubject.next(token.accessToken);
                this._authService.accessToken = token.data.token;
                localStorage.setItem('refreshToken', token.data.refreshToken);
                
                return next.handle(this.addTokenHeader(request, token.data.token));
              }),
              catchError((err) => {
                //this.isRefreshing = false;
                
                //this.tokenService.signOut();
                this._authService.signOut();
                return throwError(err);
              })
            );
        }
    
        return this.refreshTokenSubject.pipe(
          filter(token => token !== null),
          take(1),
          switchMap((token) => next.handle(this.addTokenHeader(request, this._authService.accessToken)))
        );
      }
}
